<template>
  <el-container class="pro-piloty">
    <h1>Pro piloty</h1>

    <div class="warning-wrapper" id="vystrahy">
      <the-warning :isClosable="false"/>
    </div>

    <div class="pilot-wrapper">

      <el-card class="pilot-card" :body-style="{ padding: '0px' }" >
        <!-- Meteo situace -->
        <the-weather />
      </el-card>

      <el-card class="pilot-card" :body-style="{ padding: '0px' }">
        <!-- Webkamera YouTube -->
        <iframe width="100%" height="337px" title="Webkamera LKKM" frameborder="0" allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture" src="https://www.youtube.com/embed/live_stream?channel=UC8R5ZVLK-NjlaxQluDZuwYQ&autoplay=1&controls=0&mute=1"/>
      </el-card>

      <el-card class="pilot-card" :body-style="{ padding: '0px' }">
        <!-- AIP odkaz -->
        <a style="text-decoration:none;" href="https://aim.rlp.cz/vfrmanual/actual/lkkm_text_cz.html" target="_blank">
        <div class="pilot-aip">
          <h1>
            <span>INFORMACE O LETIŠTI</span>
          </h1>
          <a href="https://aim.rlp.cz/vfrmanual/actual/lkkm_text_cz.html" target="_blank">
            <img id="pilot-aip-img" src="../../src/assets/photos/img36.jpg" alt="AIP LKKM"/>
            <!-- <img id="pilot-aip-img" src="https://aim.rlp.cz/vfrmanual/actual/ad/lkkm_voc.jpg" alt="AIP LKKM"/> -->
          </a>
        </div>
        </a>
      </el-card>

      <div style="position: relative;">
      <el-card class="pilot-card" :body-style="{ padding: '0px'}">
        
        <div style="position: absolute; bottom:-30px; left: 15px;">
          <el-radio-group v-model="map_toggle" size="small">
            <el-radio-button class="btn-el" label="true" >Mapy.cz</el-radio-button>
            <el-radio-button class="btn-el" label="false">Google Maps</el-radio-button>
          </el-radio-group>
        </div>
        <!-- Mapa Google a Mapy.cz -->
        <iframe v-if="map_toggle != 'true'" width="100%" height="337px" style="border:0;" allowfullscreen="" loading="lazy" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10409.082737464834!2d17.4168274!3d49.2902153!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xcbe9075cd76ccdd7!2zQWVyb2tsdWIgS3JvbcSbxZnDrcW-!5e0!3m2!1sen!2scz!4v1643475465145!5m2!1sen!2scz" ></iframe>
        <iframe v-if="map_toggle == 'true'" style="border:none" src="https://frame.mapy.cz/s/jumazejelu" width="100%" height="337" frameborder="0"></iframe>
      
      </el-card>
      </div>


    </div>

    <div class="form-wrapper" id="kontaktni-formular">
      <the-form-kontakt />
    </div>
    




  </el-container>
</template>

<script>

import TheWeather from './TheWeather.vue'
import TheFormKontakt from './TheFormKontakt.vue'
import TheWarning from './TheWarning.vue'

import { ref } from '@vue/reactivity'



export default {
  name: "VyhlidkoveLety",
  components: {
    TheWeather,
    TheFormKontakt,
    TheWarning

  },
  setup(){
    const map_toggle = ref("true");

    return{map_toggle}
  }
}
</script>


<style scoped>
.btn-el{
  --el-radio-button-checked-background-color: #495052;
  --el-radio-button-checked-border-color: gray;
}
.warning-wrapper{
  /* padding: 25px; */
  padding-top: 25px;
  width: 1285px;
  max-width: 90vw;
  margin: auto;
  padding-bottom: 20px;

}

.form-wrapper{
  padding-top: 8px;
  width: 1285px;
  max-width: 96%;
  margin: auto;
  padding-bottom: 20px;
}

.pilot-card{
  width: 601px;
  max-width: 90vw;
  height: 337px;
  margin: 15px;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px !important;

}

.pilot-wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 5px;
  padding-top: 20px;
  padding-bottom: 30px;

  max-width: 1300px;
}

.pilot-aip h1{
  position: relative;
  top: 43%;
  /* left: 21%; */
  z-index: 10;

  color: black;
}

.pilot-aip h1 span {
  background: rgba(255, 255, 255, 0.5);
  padding: 5px 20px 5px 20px;
	border-radius: 20px;
}

.pilot-aip{
  width: 600px;
  height: 337px;
  display: block;
  position: relative;
  margin-top: 0px;
  overflow: hidden;
  /* background-image: url("../../src/assets/photos/img36.jpg"); */
  /* background-image: url("../assets/cover/img36.jpg"); */
}


.pilot-aip img{
  filter: grayscale(60%) blur(2px);
  transition: 0.2s;
}

.pilot-aip img:hover{
  filter: grayscale(0%) blur(0px);
}

.pilot-card-text{
  position: relative;
  top: 60%;
  left: 25%;
  z-index: 10;
  font-size: 30px;

}

#pilot-aip-img {
  position: absolute;
  /* width: 900px; */
  left: -50px;
  top: -90px;

}

.pro-piloty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  background: linear-gradient(0deg, #ffffff,#ffffff, #ebeef0);
}







</style>